import React, { useState, useEffect } from "react";
import Manage from "../CreatorsDash/Manage";
import axios from "axios";
import { API } from "../../backend";
import { useTheme } from "../../Context/ThemeContext";
import styles from "../CreatorsDash/styles.module.css";
import { useTranslation } from "react-i18next";
import hello from "../../images/Vector.svg";
import hii from "../../images/eye.svg";
import Delete from "../CreatorsDash/Delete";
import { getAllUserProgress } from "../../helper/progress";
import UserDash from "./UserDash";

export default function UserSettings() {
  const [tab, setTab] = useState("Profile");
  const [progressData, setProgressData] = useState([]);
  const [stats, setStats] = useState({
    totalActiveDays: 0,
    currentStreak: 0,
    maxStreak: 0,
    playlistsCount: 0,
    totalVideosWatched: 0,
  });
  const [graphData, setGraphData] = useState([]);

  useEffect(() => {
    const token = JSON.parse(localStorage.getItem("_access_token"));
    if (token) {
      // Fetch progress data
      getAllUserProgress(token).then((data) => {
        if (data && data.success) {
          setProgressData(data.progressData);
        }
      });

      // Fetch stats from backend
      axios
        .get(`${API}/progress/stats/user`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          if (response.data.success) {
            setStats(response.data.stats);
          }
        })
        .catch((error) => console.error("Error fetching stats:", error));

      // Fetch graph data from backend
      axios
        .get(`${API}/progress/stats/graph`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          if (response.data.success && response.data.graphData) {
            // Convert object to full year (365 days) of 2026
            const activityMap = response.data.graphData;
            const yearStart = new Date(2026, 0, 1); // Jan 1, 2026
            const yearEnd = new Date(2026, 11, 31); // Dec 31, 2026

            const graphArray = [];
            for (
              let d = new Date(yearStart);
              d <= yearEnd;
              d.setDate(d.getDate() + 1)
            ) {
              const dateStr = d.toISOString().split("T")[0];
              const activity = activityMap[dateStr] || { count: 0, level: 0 };
              graphArray.push({
                date: dateStr,
                count: activity.count || 0,
                level: activity.level || 0,
              });
            }

            // Organize into weeks (7-day chunks)
            const weeks = [];
            for (let i = 0; i < graphArray.length; i += 7) {
              weeks.push(graphArray.slice(i, i + 7));
            }
            setGraphData(weeks);
          }
        })
        .catch((error) => console.error("Error fetching graph data:", error));
    }
  }, []);

  const { t, i18n } = useTranslation();

  const languages = [
    { label: "English", code: "en" },
    { label: "Hindi", code: "hi" },
    { label: "Telugu", code: "te" },
    { label: "Tamil", code: "ta" },
    { label: "Kannada", code: "kn" },
    { label: "Malayalam", code: "ml" },
    { label: "Marathi", code: "mr" },
    { label: "Gujarati", code: "gu" },
    { label: "Bengali", code: "bn" },
    { label: "Punjabi", code: "pa" },
    { label: "Urdu", code: "ur" },
    { label: "Odia", code: "or" },
    { label: "Assamese", code: "as" },
    { label: "Spanish", code: "es" },
    { label: "French", code: "fr" },
    { label: "German", code: "de" },
    { label: "Chinese", code: "zh" },
    { label: "Japanese", code: "ja" },
    { label: "Korean", code: "ko" },
  ];

  const [selectedLanguage, setSelectedLanguage] = useState(i18n.language);
  const [languageSearch, setLanguageSearch] = useState("");

  const EyeIcon = ({ open, onClick }) => (
    <span
      onClick={onClick}
      style={{
        cursor: "pointer",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        verticalAlign: "middle",
        marginLeft: 8,
        transition: "transform 0.2s cubic-bezier(.4,2,.6,1), opacity 0.2s",
      }}
      title={open ? "Hide password" : "Show password"}
    >
      {open ? (
        <img
          src={hii}
          alt="*"
          style={{
            width: 22,
            height: 22,
            filter: theme === "dark" ? "invert(1)" : "none",
          }}
        />
      ) : (
        <img
          src={hello}
          alt="*"
          style={{
            width: 22,
            height: 22,
            filter: theme === "dark" ? "invert(1)" : "none",
          }}
        />
      )}
    </span>
  );

  const [password, setPassword] = useState({
    oldPassword: "",
    newPassword: "",
  });

  const [showOld, setShowOld] = useState(false);
  const [showNew, setShowNew] = useState(false);

  const { theme, setTheme } = useTheme();

  const handlePasswordChange = () => {
    var data = JSON.stringify({
      oldPassword: password.oldPassword,
      newPassword: password.newPassword,
    });

    var config = {
      method: "put",
      url: `${API}/user/changepassword`,
      headers: {
        Authorization: `Bearer ${JSON.parse(
          localStorage.getItem("_access_token"),
        )}`,
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config).then(() => {
      alert("Password Updated Successfully");
      setPassword({
        oldPassword: "",
        newPassword: "",
      });
    });
  };

  const handleThemeChange = (e) => {
    setTheme(e.target.value);
  };

  const handleLanguageChange = (lang) => {
    setSelectedLanguage(lang.code);
    //i18n.changeLanguage(lang.code);
  };

  return (
    <div className={styles.settingsContainer}>
      <div className={styles.settingsSidebar}>
        <p
          className={tab === "Profile" ? styles.activeTab : ""}
          onClick={() => setTab("Profile")}
        >
          Profile
        </p>
        <p
          className={tab === "Update Profile" ? styles.activeTab : ""}
          onClick={() => setTab("Update Profile")}
        >
          {t("Update Profile")}
        </p>
        <p
          className={tab === "password" ? styles.activeTab : ""}
          onClick={() => setTab("password")}
        >
          {t("Password")}
        </p>
        <p
          className={tab === "language" ? styles.activeTab : ""}
          onClick={() => setTab("language")}
        >
          {t("Language")}
        </p>
        <p
          className={tab === "themes" ? styles.activeTab : ""}
          onClick={() => setTab("themes")}
        >
          {t("Themes")}
        </p>
        <p
          className={tab === "delete" ? styles.activeTab : ""}
          onClick={() => setTab("delete")}
        >
          Delete Account
        </p>
        <p
          className={tab === "logout" ? styles.activeTab : ""}
          onClick={() => setTab("logout")}
        >
          {t("Logout")}
        </p>
      </div>

      <div className={styles.settingsContent}>
        {tab === "Update Profile" && (
          <div className={styles.settingsCard}>
            <div className={styles.cardTitle}>Profile Settings</div>
            <Manage />
          </div>
        )}

        {tab === "Profile" && (
          <UserDash
            stats={stats}
            progressData={progressData}
            graphData={graphData}
          />
        )}

        {tab === "password" && (
          <div className={styles.settingsCard}>
            <div className={styles.cardTitle}>Change Password</div>

            <div style={{ position: "relative", marginBottom: 12 }}>
              <input
                className={styles.settingsInput}
                type={showOld ? "text" : "password"}
                placeholder="Old Password"
                name="oldPassword"
                value={password.oldPassword}
                onChange={(e) =>
                  setPassword({ ...password, [e.target.name]: e.target.value })
                }
                style={{ paddingRight: 36 }}
              />
              <span style={{ position: "absolute", right: 10, top: 8 }}>
                <EyeIcon open={showOld} onClick={() => setShowOld((v) => !v)} />
              </span>
            </div>

            <div style={{ position: "relative", marginBottom: 12 }}>
              <input
                className={styles.settingsInput}
                type={showNew ? "text" : "password"}
                placeholder="New Password"
                name="newPassword"
                value={password.newPassword}
                onChange={(e) =>
                  setPassword({ ...password, [e.target.name]: e.target.value })
                }
                style={{ paddingRight: 36 }}
              />
              <span style={{ position: "absolute", right: 10, top: 8 }}>
                <EyeIcon open={showNew} onClick={() => setShowNew((v) => !v)} />
              </span>
            </div>

            <button
              className={styles.updatePasswordBtn}
              onClick={handlePasswordChange}
            >
              Update Password
            </button>
          </div>
        )}

        {tab === "language" && (
          <div className={styles.settingsCard}>
            <div className={styles.cardTitle}>Language</div>

            <input
              className={styles.settingsInput}
              type="text"
              placeholder="Search language..."
              value={languageSearch}
              onChange={(e) => setLanguageSearch(e.target.value)}
              style={{ marginBottom: 10 }}
            />

            <div
              style={{ maxHeight: 150, overflowY: "auto", marginBottom: 10 }}
            >
              {languages
                .filter((lang) =>
                  lang.label
                    .toLowerCase()
                    .includes(languageSearch.toLowerCase()),
                )
                .map((lang) => (
                  <div
                    key={lang.code}
                    style={{
                      padding: "6px 12px",
                      cursor: "pointer",
                      background:
                        selectedLanguage === lang.code
                          ? "#e0e0e0"
                          : "transparent",
                    }}
                    onClick={() => handleLanguageChange(lang)}
                  >
                    {lang.label}
                  </div>
                ))}
            </div>

            <div style={{ color: "#555" }}>
              Selected:{" "}
              {languages.find((l) => l.code === selectedLanguage)?.label}
            </div>
          </div>
        )}

        {tab === "themes" && (
          <div className={styles.settingsCard}>
            <div className={styles.cardTitle}>Theme</div>
            <div style={{ display: "flex", alignItems: "center", gap: 24 }}>
              <label>
                <input
                  type="radio"
                  name="theme"
                  value="system"
                  checked={theme === "system"}
                  onChange={handleThemeChange}
                />{" "}
                System
              </label>
              <label>
                <input
                  type="radio"
                  name="theme"
                  value="light"
                  checked={theme === "light"}
                  onChange={handleThemeChange}
                />{" "}
                Light
              </label>
              <label>
                <input
                  type="radio"
                  name="theme"
                  value="dark"
                  checked={theme === "dark"}
                  onChange={handleThemeChange}
                />{" "}
                Dark
              </label>
            </div>
          </div>
        )}

        {tab === "delete" && <Delete />}

        {tab === "logout" && (
          <div className={`${styles.settingsCard} ${styles.logoutCard}`}>
            <div className={styles.cardTitle}>Logout</div>
            <button
              className={styles.logoutBtn}
              onClick={() => {
                localStorage.clear();
                window.location.href = "/";
              }}
            >
              Logout
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
